import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { cn } from '@/utils/tailwind';

interface MarkdownProps {
  text: string;
  className?: string;
}

const Markdown: React.FC<MarkdownProps> = ({ text, className }) => (
  <div
    className={cn(
      'text-variant-body1 [&_ol]:list-inside [&_ol]:list-decimal [&_ul]:list-inside [&_ul]:list-disc',
      '[&_h1]:text-variant-h1 [&_h2]:text-variant-h2 [&_h3]:text-variant-h3 [&_h4]:text-variant-h4',
      '[&_h1]:pt-2 [&_h2]:pt-2 [&_h3]:pt-2 [&_h4]:pt-2',
      '[&_table]:shadow-elevation-1 [&_table]:my-2 [&_table]:w-full [&_table]:border-collapse [&_table]:bg-white',
      '[&_th]:border-grayscale-gray2 [&_th]:bg-base-2 [&_th]:border [&_th]:px-3 [&_th]:py-2 [&_th]:text-left [&_th]:font-semibold',
      '[&_td]:border-grayscale-gray2 [&_td]:border [&_td]:px-3 [&_td]:py-2',
      '[&_a]:underline',
      className,
    )}
  >
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ children, ...props }) => (
          <a {...props} target="_blank" rel="noreferrer">
            {children}
          </a>
        ),
      }}
    >
      {text}
    </ReactMarkdown>
  </div>
);

export default Markdown;
